import React, { useEffect } from 'react';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/AppState/Common';
import { LoadingV2 } from 'src/components/Loading/LoadingV2';
import { Button } from 'src/domains/common/components/button/button';
import { SelfExcludedSection } from './SelfExcluded';
import { SelfExcludedTabState } from './SelfExcludedTab.state';
import { ErrorMessage, Header, PageHeader, SelfExcludedTabContainer } from './SelfExcludedTab.style';

export const SelfExcludedTab = observer('SelfExcludedTab', (): React.ReactElement => {
    const common = useCommon();
    const state = SelfExcludedTabState.get(common);
    const isFinished = !state.isLoading && !state.hasError;

    useEffect(() => {
        const intervalId = setInterval(() => {
            state.refresh().catch((error) => {
                console.error('SelfExcludedTab refrexsh error', error);
            });
        }, 10000);

        return (): void => {
            clearInterval(intervalId);
        };
    }, [state]);

    if (state.isLoading) {
        return (
            <LoadingV2
                dataTest='self-excluded-tab-loading'
                title='Loading...'
            />
        );
    }

    return (
        <SelfExcludedTabContainer data-test='self-exclusion-changes'>
            <PageHeader>
                <Header data-test='main-header'>Self Excluded</Header>
                <Button
                    variant='link'
                    size='sm'
                    dataTest='refresh-button'
                    onClick={(): void => {
                        state.refresh().catch((error) => {
                            console.error('SelfExcludedTab refresh error', error);
                        });
                    }}
                >
                    Refresh
                </Button>
            </PageHeader>

            {state.hasError ? <ErrorMessage>Error during fetching data</ErrorMessage> : null}

            <SelfExcludedSection
                type='your'
                header='Assigned To You'
                dataTest='self-exclusion-changes-assigned-to-you'
                notifications={state.yourNotifications}
                state={state}
                isFinished={isFinished}
            />
            <SelfExcludedSection
                type='none'
                header='Pending Requests'
                dataTest='self-exclusion-changes-pending-requests'
                notifications={state.noneNotifications}
                state={state}
                isFinished={isFinished}
            />
            <SelfExcludedSection
                type='other'
                header='Assigned To Others'
                dataTest='self-exclusion-changes-assigned-to-others'
                notifications={state.otherNotifications}
                state={state}
                isFinished={isFinished}
            />
        </SelfExcludedTabContainer>
    );
});
